import { api } from './client';
import type { Page } from './catalogs';
import type { CancellableState } from './cancellation';

export interface AdvanceReportItem {
  id?: string;
  line_number: number;
  cost_item_id?: string | null;
  contractor_id?: string | null;
  supplier_doc_number?: string | null;
  supplier_doc_date?: string | null;
  description?: string | null;
  expense_account_code?: string | null;
  amount_without_vat: string;
  vat_rate_id?: string | null;
  vat_amount: string;
  total_amount: string;
  project_id?: string | null;
}

export interface AdvanceReportListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  employee_id: string;
  total_amount: string;
  posted: boolean;
  deletion_mark: boolean;
  external_source?: string | null;
  project_id?: string | null;
  // Block 5.3f:
  state?: CancellableState;
}

export interface AdvanceReport extends AdvanceReportListItem {
  advance_payment_id: string | null;
  advance_received: string; // сумма выданного аванса по связанному РКО
  amount_without_vat: string;
  vat_amount: string;
  purpose: string | null;
  posted_at: string | null;
  comment: string | null;
  items: AdvanceReportItem[];
  // Block 5.3f:
  cancelled_at?: string | null;
  cancellation_reason?: string | null;
}

export interface AdvanceReportCreate {
  organization_id: string;
  document_number: string;
  document_date: string;
  employee_id: string;
  advance_payment_id?: string | null;
  purpose?: string | null;
  comment?: string | null;
  items: AdvanceReportItem[];
  project_id?: string | null;
}

export type AdvanceReportUpdate = Partial<AdvanceReportCreate>;

export const advanceReports = {
  list: (params?: {
    organization_id?: string; employee_id?: string;
    posted?: boolean; limit?: number; offset?: number;
  }) =>
    api.get<Page<AdvanceReportListItem>>('/advance-reports', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<AdvanceReport>(`/advance-reports/${id}`).then((r) => r.data),
  create: (payload: AdvanceReportCreate) =>
    api.post<AdvanceReport>('/advance-reports', payload).then((r) => r.data),
  update: (id: string, payload: AdvanceReportUpdate) =>
    api.patch<AdvanceReport>(`/advance-reports/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/advance-reports/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<AdvanceReport>(`/advance-reports/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<AdvanceReport>(`/advance-reports/${id}/unpost`).then((r) => r.data),
  cancel: (id: string, reason: string) =>
    api.post(`/advance-reports/${id}/cancel`, { cancellation_reason: reason }).then((r) => r.data),
};
